<template>
  <div id="ServiceCategories">
    <button class="category" :class="{'active': selectedCategory && (category.id === selectedCategory.id)}" v-for="(category, index) in categories" :key="index" @click="handleClick(category)">
      {{ category.title }}
    </button>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../config/constants";
export default {
  name: "ServiceCategories",
  props: ['selectedCategory'],
  data() {
    return {
      categories: [{id: 1020234, title: 'All'}]
    }
  },
  mounted() {
    this.getCategories()
  },
  methods: {
    handleClick(category) {
      this.$emit('selectCategory', category)
    },
    async getCategories() {
      const payload = {
          user_id: this.$store.getters.user_id,
        }
      const res = await axios.post(config.api_env + '/application/api/u/marketplace/get-categories', payload, config.options)
      if (res.data.success && res.data.categories && res.data.categories.length) {
        this.categories.push(...res.data.categories)
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
      }
    },
  },
}
</script>

<style lang="less">
#ServiceCategories {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-bottom: 80px;

  .category {
    min-width: 136px;
    background-color: #1F1E1E;
    border: 1px solid #1F1E1E;
    color: #fff;
    font-size: 1.6rem;
    line-height: 1.8rem;
    border-radius: 30px;
    padding: 8px 14px;

    &:hover, &.active {
      color: #1F1E1E;
      font-family: "Raptor V3 Black";
      background-color: #fff;
    }
  }
}
</style>